export interface ContentBlock {
  type: 'p' | 'h2' | 'quote';
  text: string;
}

export interface TimelineItem {
  time: string;
  text: string;
}

export interface Article {
  id: string;
  title: string;
  excerpt: string;
  category: string;
  categoryName: string;
  cover: string;
  tags: string[];
  author: string;
  date: string;
  views: number;
  hot: number;
  timeline: TimelineItem[];
  content: ContentBlock[];
}

export interface Category {
  slug: string;
  name: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  {
    slug: 'star',
    name: '明星动态',
    icon: 'ri-vip-crown-2-line',
    description: '追踪艺人公开行程、合作动向与工作室回应，把碎片消息拼成完整脉络。',
  },
  {
    slug: 'influencer',
    name: '网红圈',
    icon: 'ri-live-line',
    description: '聚焦内容创作者的涨粉、转型与合作变动，围观镜头之外的团队故事。',
  },
  {
    slug: 'screen',
    name: '影视综艺',
    icon: 'ri-film-line',
    description: '剧组路透、综艺赛制与选角调整，第一时间整理项目进度的真实走向。',
  },
  {
    slug: 'life',
    name: '情感生活',
    icon: 'ri-heart-3-line',
    description: '从公开互动里寻找线索，理性看待被偶遇、被同框的各类传闻。',
  },
  {
    slug: 'business',
    name: '带货打假',
    icon: 'ri-shopping-bag-3-line',
    description: '关注直播选品、商品参数与售后争议，还原一场场翻车事件的来龙去脉。',
  },
];

export const articles: Article[] = [
  {
    id: 'a01',
    title: '某顶流男演员深夜聚餐同行者曝光，工作室：属正常合作关系',
    excerpt:
      '一组深夜聚餐画面在网络流传，画面中的同行人员身份引发大量猜测。工作室随后发布简短说明，称当晚为项目合作洽谈，现场还有多位工作人员在场。',
    category: 'star',
    categoryName: '明星动态',
    cover:
      'https://readdy.ai/api/search-image?query=abstract%20neon-lit%20city%20street%20at%20night%20with%20warm%20red%20and%20gold%20light%20trails%2C%20stylized%20editorial%20illustration%2C%20cinematic%20bokeh%2C%20dramatic%20moody%20atmosphere%2C%20no%20text%2C%20high%20detail&width=800&height=600&seq=chigua-cover-01&orientation=landscape',
    tags: ['深夜行程', '工作室回应', '合作洽谈'],
    author: '瓜田观察员',
    date: '2026-09-09',
    views: 128540,
    hot: 98,
    timeline: [
      { time: '09-07 22:40', text: '有网友在社交平台发布一组餐厅外画面，称偶遇两位艺人同行用餐。' },
      { time: '09-08 09:10', text: '相关话题进入热搜榜前二十，讨论量持续攀升，粉丝开始自发核对当日行程。' },
      { time: '09-08 18:30', text: '工作室发布说明，指出当晚为项目合作洽谈，现场有工作人员陪同。' },
      { time: '09-09 11:00', text: '多位参与项目的制作人员在评论区补充说明，事件热度逐步回落。' },
    ],
    content: [
      { type: 'p', text: '一条深夜聚餐的偶遇画面，往往能在几个小时内被反复解读出十几个版本。这次事件的起点，只是一段拍摄距离较远、光线并不理想的短视频。' },
      { type: 'h2', text: '画面里到底拍到了什么' },
      { type: 'p', text: '从公开流传的片段来看，画面主要呈现的是餐厅门外的通道场景，同行人数在四人以上，并非单独两人。由于拍摄者与对象之间隔着玻璃和路灯反光，人物轮廓并不清晰，这也为后续的猜测留下了空间。' },
      { type: 'h2', text: '工作室的说明与时间线对不上吗' },
      { type: 'p', text: '工作室在第二天傍晚给出回应，确认当晚确有聚餐，但强调是围绕新项目的合作洽谈。有网友把说明中的时间点与当日公开行程做了比对，发现在傍晚之后的安排确实是空档期，因此这份说明在逻辑上与行程记录并不冲突。' },
      { type: 'quote', text: '把一条短视频当作完整证据链，是吃瓜时最容易踩的坑。' },
      { type: 'h2', text: '为什么这类消息总能迅速发酵' },
      { type: 'p', text: '一方面，顶流艺人的每一次公开露面本身就自带流量；另一方面，深夜、聚餐、同行这些关键词天然带有叙事张力。当信息越模糊，二次创作的空间就越大，话题也就越容易被推高。' },
      { type: 'p', text: '截至发稿，双方均未再补充新的说明。对于此类尚未有更多实质进展的消息，围观之余不妨多留一分耐心，等更多信源交叉验证后再下判断。' },
    ],
  },
  {
    id: 'a02',
    title: '千万粉丝带货主播直播间翻车，同款商品参数与宣传不符引热议',
    excerpt:
      '多位消费者反映，某直播间主推的一款家居商品，实测参数与直播时的口头描述存在明显差异。主播团队随后公布退款方案，并暂停该品类上新。',
    category: 'business',
    categoryName: '带货打假',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20studio%20scene%20with%20glowing%20screen%20and%20warm%20amber%20and%20red%20lighting%2C%20abstract%20online%20shopping%20concept%2C%20minimal%20editorial%20photography%2C%20soft%20shadows%2C%20no%20text%2C%20high%20detail&width=800&height=600&seq=chigua-cover-02&orientation=landscape',
    tags: ['直播选品', '参数争议', '退款方案'],
    author: '打假小分队',
    date: '2026-09-08',
    views: 96420,
    hot: 95,
    timeline: [
      { time: '09-05 20:00', text: '直播间主推家居商品，主播口头强调“同价位里的高配参数”。' },
      { time: '09-06 14:20', text: '首批消费者收到货后发帖，晒出实测数据与直播截图对比。' },
      { time: '09-07 10:00', text: '话题登上消费类榜单，多位测评博主加入讨论，公布拆解结果。' },
      { time: '09-08 16:00', text: '主播团队公布全额退款与运费补偿方案，并暂停该品类上新。' },
    ],
    content: [
      { type: 'p', text: '“高配参数”四个字，在很多直播间里被反复使用，但真正决定体验的往往是那些没有被念出来的细节。这次的争议，就集中在一款家居商品的实测表现上。' },
      { type: 'h2', text: '消费者晒出的对比' },
      { type: 'p', text: '从多位消费者公开的截图看，争议点主要是两点：一是直播时提到的某个数值，与商品详情页标注存在差距；二是实际使用中的效果，与演示环节的展示效果并不一致。' },
      { type: 'h2', text: '团队的处理方式' },
      { type: 'p', text: '在舆论持续两天后，团队给出了相对完整的处理方案：对已下单用户开放全额退款，承担往返运费，同时暂停该品类的后续上架，并承诺重新梳理选品流程。' },
      { type: 'quote', text: '直播间的口头承诺和详情页的白纸黑字，理应指向同一个标准。' },
      { type: 'h2', text: '这件事给围观者的提醒' },
      { type: 'p', text: '下单前先看详情页参数、保留直播回放截图、收到货后及时验货并留存证据，这些看起来麻烦的步骤，恰恰是保护自己的有效方式。这次事件的快速解决，也和消费者把证据整理得足够清晰有关。' },
      { type: 'p', text: '对于行业而言，选品流程是否透明、宣传口径是否统一，依旧是反复被讨论的老问题。' },
    ],
  },
  {
    id: 'a03',
    title: '热播剧组杀青照流出，男女主同框互动被指关系升温',
    excerpt:
      '一组剧组杀青合照在网络传播，画面中两位主演的互动被解读出多种含义。剧组工作人员回应称，杀青现场气氛轻松，每位演员都有类似合影。',
    category: 'screen',
    categoryName: '影视综艺',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20film%20set%20with%20warm%20gold%20spotlights%20and%20soft%20red%20ambient%20glow%2C%20abstract%20cinema%20production%20concept%2C%20editorial%20photography%2C%20shallow%20depth%20of%20field%2C%20no%20text%2C%20high%20detail&width=800&height=600&seq=chigua-cover-03&orientation=landscape',
    tags: ['杀青合照', '剧组回应', '合作传闻'],
    author: '剧组前线',
    date: '2026-09-07',
    views: 87210,
    hot: 92,
    timeline: [
      { time: '09-05 19:30', text: '剧组官方账号发布杀青动态，配发一组现场合照。' },
      { time: '09-06 08:50', text: '有网友截取其中一张照片的局部，认为两位主演站位与动作“不寻常”。' },
      { time: '09-06 21:10', text: '剧组工作人员在评论区回应，称杀青现场为全体合影，氛围轻松。' },
      { time: '09-07 15:00', text: '更多现场花絮照片流出，显示多位演员均有相似互动，话题降温。' },
    ],
    content: [
      { type: 'p', text: '一部剧杀青，最先流出的往往不是成片，而是片场照片。这次的照片本身并不特殊，特殊的是被截取出来的那一小块区域。' },
      { type: 'h2', text: '为什么局部截图容易误导' },
      { type: 'p', text: '一张群像合照经过裁剪和放大后，人物之间的关系会被视觉强行拉近。原本隔着两三个人的位置，在局部图里看起来像是并肩而立。这类断章取义在娱乐话题里非常常见。' },
      { type: 'h2', text: '完整的现场是什么样' },
      { type: 'p', text: '随后流出的完整花絮显示，杀青当天参与合影的人员超过二十位，多位演员之间有递道具、搭肩、互开玩笑的互动，并非只有两位主演如此。' },
      { type: 'quote', text: '先看全景，再看局部，能过滤掉八成的无效猜测。' },
      { type: 'h2', text: '剧组的态度' },
      { type: 'p', text: '剧组方面并未就传闻发布正式声明，只是在评论区做了简短说明。从过往经验看，对于尚在后期制作阶段的项目，片方通常不会主动放大主演话题，以免影响播出节奏。' },
      { type: 'p', text: '目前该剧已进入后期阶段，具体档期尚未公布，围观者可以关注官方账号的后续动态。' },
    ],
  },
  {
    id: 'a04',
    title: '女团成员疑似取关前队友，粉丝整理时间线还原事件经过',
    excerpt:
      '有粉丝发现，某女团现役成员的关注列表发生变化，随后双方粉丝各自整理时间线。经纪公司未正面回应，仅表示艺人社交账号由本人管理。',
    category: 'influencer',
    categoryName: '网红圈',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20stage%20lights%20with%20warm%20pink%20and%20gold%20glow%20in%20dark%20auditorium%2C%20abstract%20music%20performance%20concept%2C%20editorial%20photography%2C%20dramatic%20bokeh%2C%20no%20text%2C%20high%20detail&width=800&height=600&seq=chigua-cover-04&orientation=landscape',
    tags: ['关注列表', '时间线', '粉丝考据'],
    author: '瓜田观察员',
    date: '2026-09-06',
    views: 74380,
    hot: 88,
    timeline: [
      { time: '09-04 23:10', text: '粉丝发现某成员关注数量减少一位，截图后在超话内讨论。' },
      { time: '09-05 10:00', text: '话题延伸出多条“考据帖”，双方粉丝各自整理互动时间线。' },
      { time: '09-05 20:40', text: '经纪公司回应媒体询问，表示账号由艺人本人运营，不便代为说明。' },
      { time: '09-06 12:00', text: '多家粉丝站呼吁理性看待，相关讨论量逐步下降。' },
    ],
    content: [
      { type: 'p', text: '一个关注列表的变化，能掀起多大的浪？在这条超话里，答案是连续两天的讨论热潮。' },
      { type: 'h2', text: '事件的起点' },
      { type: 'p', text: '起因是有粉丝在例行“考古”时，发现某位成员的关注数量比前一天少了一个。由于关注列表并不公开，粉丝只能根据历史截图进行比对，推断出取消关注的对象。' },
      { type: 'h2', text: '考据帖里有哪些内容' },
      { type: 'p', text: '随后出现的考据帖，把过去两年里两人的公开互动、同框次数、互相提及的节点整理成时间线。这些整理本身有一定参考价值，但也存在主观解读的成分。' },
      { type: 'quote', text: '粉丝整理的线索值得看，但结论仍需要当事人确认。' },
      { type: 'h2', text: '公司的回应' },
      { type: 'p', text: '经纪公司仅表示社交账号由艺人本人管理，没有进一步说明。这类模糊回应既没有证实也没有否认，反而让讨论延续了一段时间。' },
      { type: 'p', text: '随着更多粉丝站发出理性呼吁，事件热度在第三天明显回落。' },
    ],
  },
  {
    id: 'a05',
    title: '网红餐厅排队两小时被曝使用预制菜，店家连发三条声明',
    excerpt:
      '一位顾客发布探店视频，称餐厅招牌菜疑似为预制加热。餐厅随后连发三条声明，公开后厨流程与部分食材采购凭证，并邀请顾客到店参观。',
    category: 'business',
    categoryName: '带货打假',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20cozy%20restaurant%20interior%20with%20warm%20amber%20lamp%20light%20and%20red%20accents%2C%20abstract%20dining%20concept%2C%20editorial%20food%20photography%2C%20soft%20shadows%2C%20no%20text%2C%20high%20detail&width=800&height=600&seq=chigua-cover-05&orientation=landscape',
    tags: ['探店', '预制菜', '后厨公开'],
    author: '打假小分队',
    date: '2026-09-05',
    views: 68930,
    hot: 85,
    timeline: [
      { time: '09-03 12:20', text: '探店视频发布，质疑招牌菜口感接近预制加热，视频迅速传播。' },
      { time: '09-03 19:00', text: '餐厅发布第一条声明，否认全部使用预制菜，说明部分酱料为中央厨房统一配送。' },
      { time: '09-04 10:30', text: '第二、第三条声明接连发布，公开采购凭证并邀请顾客到店参观后厨。' },
      { time: '09-05 09:00', text: '发布视频的顾客更新动态，称已接受邀请，将实地探访后给出结论。' },
    ],
    content: [
      { type: 'p', text: '“预制菜”三个字，近两年几乎成了餐饮话题的引爆点。这次的争议，来自一条不到两分钟的探店视频。' },
      { type: 'h2', text: '顾客的质疑依据' },
      { type: 'p', text: '视频中，顾客从出餐速度、菜品形态和口感三个角度提出疑问，认为招牌菜的上桌时间明显短于现炒所需，且不同桌次的成品形态高度一致。' },
      { type: 'h2', text: '店家的三条声明说了什么' },
      { type: 'p', text: '第一条声明确认部分酱料由中央厨房统一配送，但强调主料为当日现切；第二条公开了部分食材的采购凭证；第三条则邀请顾客与媒体到店参观后厨，并提出可以现场点单验证。' },
      { type: 'quote', text: '预制与现制不是非黑即白的判断题，透明才是。' },
      { type: 'h2', text: '争议背后的行业现实' },
      { type: 'p', text: '事实上，连锁餐饮使用标准化半成品早已是公开做法，真正影响消费者判断的，是店内的信息是否透明、宣传口径是否与实际一致。' },
      { type: 'p', text: '截至发稿，双方约定实地探访的时间尚未公布，我们会持续关注后续进展。' },
    ],
  },
  {
    id: 'a06',
    title: '恋综嘉宾节目外同游被偶遇，双方经纪公司暂未回应',
    excerpt:
      '有网友称在景区偶遇两位恋综嘉宾同游，并发布了背影照片。由于照片中的人物辨识度有限，双方经纪公司均未就此作出回应。',
    category: 'life',
    categoryName: '情感生活',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20sunset%20mountain%20trail%20with%20warm%20orange%20and%20soft%20rose%20sky%20tones%2C%20abstract%20travel%20romance%20concept%2C%20editorial%20photography%2C%20soft%20focus%2C%20no%20text%2C%20high%20detail&width=800&height=600&seq=chigua-cover-06&orientation=landscape',
    tags: ['偶遇', '恋综', '暂未回应'],
    author: '情感观察室',
    date: '2026-09-04',
    views: 59210,
    hot: 80,
    timeline: [
      { time: '09-02 17:40', text: '网友在社交平台发布景区背影照，称偶遇两位恋综嘉宾同游。' },
      { time: '09-03 09:00', text: '话题进入综艺讨论榜，粉丝开始比对外套与背包款式。' },
      { time: '09-03 22:00', text: '两家经纪公司均未回应媒体询问。' },
      { time: '09-04 14:00', text: '有同行游客补充说明，称当日游客众多，难以确认具体人选。' },
    ],
    content: [
      { type: 'p', text: '恋综结束之后，观众对嘉宾的现实走向总是格外关心。这次的偶遇照片，恰恰卡在“像”与“不像”之间。' },
      { type: 'h2', text: '照片的辨识度有多高' },
      { type: 'p', text: '从公开的照片看，画面为逆光远景，人物只有背影和侧影，服装为当季常见款式。所谓“同款”比对，主要依靠粉丝整理的穿搭索引，缺乏唯一性特征。' },
      { type: 'h2', text: '为什么没有官方回应' },
      { type: 'p', text: '对于恋爱类节目之后的关系传闻，经纪公司通常采取“不回应、不引导”的策略。一旦回应，反而会把话题重新推高，因此沉默也是一种常见的处理方式。' },
      { type: 'quote', text: '偶遇照片最大的问题不是真假，而是它无法被证伪。' },
      { type: 'h2', text: '理性围观的小建议' },
      { type: 'p', text: '在没有正面照、没有同行者说明、没有官方回应的三重缺失下，这类讨论更适合当作综艺余温来看待，不必过度代入。' },
      { type: 'p', text: '节目组尚未公布衍生内容计划，两位嘉宾近期也无公开同台行程。' },
    ],
  },
  {
    id: 'a07',
    title: '老牌选秀导师新综艺被指剧本感重，节目组称赛制全程公开',
    excerpt:
      '新一季综艺开播两期，多位选手的晋级路径被观众质疑“过于巧合”。节目组回应称赛制与评分规则提前公开，不存在预设结果。',
    category: 'screen',
    categoryName: '影视综艺',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20television%20studio%20with%20warm%20gold%20and%20red%20stage%20lighting%2C%20abstract%20talent%20show%20concept%2C%20editorial%20photography%2C%20dramatic%20contrast%2C%20no%20text%2C%20high%20detail&width=800&height=600&seq=chigua-cover-07&orientation=landscape',
    tags: ['赛制争议', '剧本感', '节目组回应'],
    author: '剧组前线',
    date: '2026-09-03',
    views: 51670,
    hot: 76,
    timeline: [
      { time: '09-01 20:00', text: '新一季综艺第二期播出，两位选手的晋级引发讨论。' },
      { time: '09-02 11:20', text: '有观众整理剪辑时间线，认为节目组对特定选手的镜头分配不均衡。' },
      { time: '09-02 18:00', text: '节目组发布说明，强调赛制与评分规则在开播前已全部公开。' },
      { time: '09-03 10:00', text: '多位选手发布练习室花絮，节目话题转向舞台表现本身。' },
    ],
    content: [
      { type: 'p', text: '综艺有没有剧本，是观众讨论了十几年的问题。这次的争议，主要围绕剪辑与镜头分配展开。' },
      { type: 'h2', text: '观众质疑的两个点' },
      { type: 'p', text: '一是镜头时长明显向个别选手倾斜，二是关键对决的剪辑节奏刻意营造悬念。从技术角度看，剪辑本就是叙事手段，但过度倾斜确实会影响观感公平。' },
      { type: 'h2', text: '节目组的说法' },
      { type: 'p', text: '节目组表示，赛制规则、评分维度在开播前已通过官方渠道公开，每位选手的评分由现场评委与线上投票共同决定，不存在预设晋级名单。' },
      { type: 'quote', text: '剪辑可以制造悬念，但不能替代赛制的公信力。' },
      { type: 'h2', text: '如何判断一档节目的公平性' },
      { type: 'p', text: '与其纠结某一期的镜头时长，不如观察整个赛季的规则执行是否一致、评分是否可追溯。这些结构性的信息，比单期剪辑更有参考价值。' },
      { type: 'p', text: '节目将进入淘汰赛阶段，后续赛制调整值得继续关注。' },
    ],
  },
  {
    id: 'a08',
    title: '百万粉博主深夜长文宣布暂停更新，疑因团队内部矛盾',
    excerpt:
      '一位长期更新生活类内容的博主发布长文，宣布账号暂停更新。文中提到创作团队在内容方向上存在分歧，但未点名任何合作方。',
    category: 'influencer',
    categoryName: '网红圈',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20dim%20creator%20desk%20at%20night%20with%20warm%20amber%20desk%20lamp%20and%20glowing%20monitor%2C%20abstract%20content%20creation%20concept%2C%20editorial%20photography%2C%20cozy%20melancholic%20mood%2C%20no%20text%2C%20high%20detail&width=800&height=600&seq=chigua-cover-08&orientation=landscape',
    tags: ['暂停更新', '团队矛盾', '长文回应'],
    author: '瓜田观察员',
    date: '2026-09-02',
    views: 47850,
    hot: 73,
    timeline: [
      { time: '08-31 23:40', text: '博主发布长文，宣布账号暂停更新，未给出具体复更时间。' },
      { time: '09-01 09:00', text: '粉丝在评论区表达支持，相关话题进入创作者榜单。' },
      { time: '09-01 16:30', text: '多位同领域博主发文声援，讨论创作者的权益与分工问题。' },
      { time: '09-02 12:00', text: '博主在评论区补充说明，称仅为阶段性休息，账号不会注销。' },
    ],
    content: [
      { type: 'p', text: '内容创作者的“暂停更新”，往往不是某一次争吵的结果，而是长期压力累积到临界点后的选择。' },
      { type: 'h2', text: '长文里说了什么' },
      { type: 'p', text: '博主在文中提到，过去半年内容节奏不断加快，团队在选题方向与商业化尺度上出现分歧。文中没有指名任何合作方，也没有披露合同细节，措辞相对克制。' },
      { type: 'h2', text: '粉丝的反应' },
      { type: 'p', text: '评论区以支持为主，不少老粉回忆起账号早期的风格。也有理性声音提醒，暂停更新是个人选择，不必过度解读为“被封杀”或“被雪藏”。' },
      { type: 'quote', text: '创作者的休息权，同样值得被认真对待。' },
      { type: 'h2', text: '行业层面的思考' },
      { type: 'p', text: '随着账号规模扩大，个人创作逐渐变成团队协作，收益分配、内容主导权、更新频率都会成为潜在摩擦点。这类矛盾并不罕见，只是很少被公开讨论。' },
      { type: 'p', text: '博主表示会在调整好状态后再回来，账号此前的作品将保持公开。' },
    ],
  },
  {
    id: 'a09',
    title: '歌手巡演票价争议，主办方公布成本明细解释定价逻辑',
    excerpt:
      '某歌手巡演开票后，部分场次票价被指偏高。主办方随后发布长图，公开舞台搭建、场地租赁等主要成本项，并说明不同场次的定价差异。',
    category: 'star',
    categoryName: '明星动态',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20large%20concert%20stage%20with%20warm%20gold%20and%20deep%20red%20beam%20lights%2C%20abstract%20live%20music%20concept%2C%20editorial%20photography%2C%20crowd%20silhouettes%2C%20no%20text%2C%20high%20detail&width=800&height=600&seq=chigua-cover-09&orientation=landscape',
    tags: ['巡演票价', '成本明细', '开票争议'],
    author: '演出观察',
    date: '2026-09-01',
    views: 43120,
    hot: 70,
    timeline: [
      { time: '08-30 12:00', text: '巡演公布场次与票价区间，部分城市票价高于预期。' },
      { time: '08-31 10:00', text: '相关话题引发讨论，观众关注不同场次的定价差异。' },
      { time: '08-31 20:00', text: '主办方发布成本明细长图，逐项说明主要支出构成。' },
      { time: '09-01 14:00', text: '部分场次开票即告售罄，争议重心转向购票体验。' },
    ],
    content: [
      { type: 'p', text: '演唱会票价一直是观众最敏感的话题之一，而这一次主办方选择把成本摊开来讲。' },
      { type: 'h2', text: '票价差异从哪来' },
      { type: 'p', text: '根据主办方公布的长图，不同城市的基础成本差异主要来自场馆规模、租赁档期和物流距离。大型体育馆的单场搭建与撤场成本，明显高于剧院型场馆。' },
      { type: 'h2', text: '观众买账吗' },
      { type: 'p', text: '从评论区反馈看，公开明细的做法获得了部分理解，但仍有观众认为，明细的颗粒度还不够细，例如宣传推广与票务服务费未单独列出。' },
      { type: 'quote', text: '公开成本是第一步，让价格与体验匹配才是关键。' },
      { type: 'h2', text: '购票体验同样重要' },
      { type: 'p', text: '在开票当日，部分观众反映排队体验不佳。演出市场的热度居高不下，票务系统的承载能力和退改规则，正在成为新的关注焦点。' },
      { type: 'p', text: '巡演后续场次将陆续开票，主办方表示会优化购票流程。' },
    ],
  },
  {
    id: 'a10',
    title: '短剧顶流演员早年采访被翻出，网友评价两极分化',
    excerpt:
      '随着一部短剧热播，主演早年的一段采访视频被网友翻出。视频中的发言被部分人解读为态度转变，也有观众认为应当结合当时语境理解。',
    category: 'screen',
    categoryName: '影视综艺',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20vertical%20short%20drama%20screen%20glow%20with%20warm%20orange%20and%20teal%20tint%2C%20abstract%20mobile%20video%20concept%2C%20editorial%20photography%2C%20moody%20dark%20background%2C%20no%20text%2C%20high%20detail&width=800&height=600&seq=chigua-cover-10&orientation=landscape',
    tags: ['早年采访', '态度争议', '语境解读'],
    author: '剧组前线',
    date: '2026-08-30',
    views: 39870,
    hot: 66,
    timeline: [
      { time: '08-28 21:00', text: '主演短剧单日播放量刷新平台纪录，演员热度快速上升。' },
      { time: '08-29 13:00', text: '网友翻出三年前的一段采访视频，截取其中一句发言传播。' },
      { time: '08-29 19:30', text: '完整采访版本被重新上传，上下文显示当时的提问语境不同。' },
      { time: '08-30 11:00', text: '讨论逐渐分化，观众更多聚焦其在剧中的表演。' },
    ],
    content: [
      { type: 'p', text: '短剧的爆火速度，往往快到演员自己都来不及反应。而热度带来的第一波考验，通常是“考古”。' },
      { type: 'h2', text: '被截取的那句话' },
      { type: 'p', text: '引发讨论的是一句关于“职业规划”的表述，单独看确实容易被理解为前后矛盾。但完整采访中，主持人此前的提问指向的是另一个具体项目，语境并不相同。' },
      { type: 'h2', text: '两种截然不同的看法' },
      { type: 'p', text: '一部分观众认为，公众人物的公开表达应当前后一致；另一部分观众则认为，人在不同阶段改变想法是常态，不应以旧言否定新作。' },
      { type: 'quote', text: '把三年前的语境直接搬到今天，本身就是一种失真。' },
      { type: 'h2', text: '作品才是长线筹码' },
      { type: 'p', text: '从后续数据看，围绕表演本身的讨论量正在超过对旧采访的争论。对于快速走红的演员而言，持续的优质产出，比一次性的热搜更有价值。' },
      { type: 'p', text: '该演员的后续作品已在筹备中，具体信息以官方发布为准。' },
    ],
  },
  {
    id: 'a11',
    title: '带货团队离职员工爆料选品流程，行业潜规则再被讨论',
    excerpt:
      '一位自称从某带货团队离职的从业者发布长文，讲述选品会议的实际流程。文中提到的“上架排序”机制，引发了关于行业透明度的新一轮讨论。',
    category: 'business',
    categoryName: '带货打假',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20warehouse%20with%20warm%20amber%20industrial%20lighting%20and%20stacked%20cardboard%20boxes%2C%20abstract%20ecommerce%20logistics%20concept%2C%20editorial%20photography%2C%20soft%20shadows%2C%20no%20text%2C%20high%20detail&width=800&height=600&seq=chigua-cover-11&orientation=landscape',
    tags: ['离职爆料', '选品流程', '行业讨论'],
    author: '打假小分队',
    date: '2026-08-29',
    views: 35640,
    hot: 62,
    timeline: [
      { time: '08-27 22:00', text: '自称离职员工发布长文，描述选品会议的实际流程。' },
      { time: '08-28 10:00', text: '多位从业者在评论区补充行业普遍做法，讨论量上升。' },
      { time: '08-28 17:00', text: '被提及的团队未作正面回应，仅表示选品有完整审核流程。' },
      { time: '08-29 12:00', text: '话题转向对行业规范化的讨论，多家机构发布选品倡议。' },
    ],
    content: [
      { type: 'p', text: '一篇离职长文，把直播带货里很少被摆到台面上的选品环节，推到了聚光灯下。' },
      { type: 'h2', text: '长文讲了什么' },
      { type: 'p', text: '作者描述，选品会通常会根据销量预估、佣金比例和库存情况，对商品进行排序，位置越靠前的商品获得的讲解时间越长。这一机制本身并不违规，但普通消费者往往并不知情。' },
      { type: 'h2', text: '哪些是可验证的' },
      { type: 'p', text: '需要说明的是，长文中的部分内容为个人经历，暂无法逐条核实。可以确认的是，行业内的确存在“坑位”与“讲解时长”相关联的普遍现象。' },
      { type: 'quote', text: '让消费者知道商品是怎么被选出来的，比争论谁在说谎更重要。' },
      { type: 'h2', text: '规范化正在推进' },
      { type: 'p', text: '近期多家机构发布选品倡议，提出公示基础审核信息、建立抽检机制等建议。这些举措能否落地，还需要时间检验。' },
      { type: 'p', text: '我们会持续跟踪相关倡议的后续执行情况。' },
    ],
  },
  {
    id: 'a12',
    title: '综艺常驻嘉宾疑似换人，路透图显示新面孔加入录制',
    excerpt:
      '有网友曝光新一季综艺的录制路透，画面中出现一位未在往季常驻的嘉宾。节目组尚未公布完整阵容，粉丝对换人一事看法不一。',
    category: 'screen',
    categoryName: '影视综艺',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20outdoor%20variety%20show%20set%20with%20warm%20daylight%20and%20golden%20accents%2C%20abstract%20production%20crew%20concept%2C%20editorial%20photography%2C%20soft%20natural%20tones%2C%20no%20text%2C%20high%20detail&width=800&height=600&seq=chigua-cover-12&orientation=landscape',
    tags: ['阵容调整', '录制路透', '粉丝讨论'],
    author: '剧组前线',
    date: '2026-08-28',
    views: 31420,
    hot: 58,
    timeline: [
      { time: '08-26 15:00', text: '网友发布录制现场路透图，画面中出现新面孔。' },
      { time: '08-27 09:30', text: '粉丝比对行程后发现，一位往季常驻嘉宾近期档期与其他项目冲突。' },
      { time: '08-27 18:00', text: '节目组回应称完整阵容将在开播前统一公布。' },
      { time: '08-28 11:00', text: '讨论趋于理性，观众开始关注新赛制的具体设定。' },
    ],
    content: [
      { type: 'p', text: '一档走过数季的综艺，每一次阵容调整都会牵动老观众的心。这次的路透图，让讨论提前升温。' },
      { type: 'h2', text: '路透图透露了什么' },
      { type: 'p', text: '照片拍摄于户外录制场地，画面中除熟悉的面孔外，还出现了一位新嘉宾。由于行程公开信息显示某位常驻嘉宾近期有其他项目在身，“换人”的说法随之出现。' },
      { type: 'h2', text: '节目组的回应' },
      { type: 'p', text: '节目组表示，完整阵容会在开播前统一公布，目前流传的画面属于录制间隙的片段，不代表最终播出内容。' },
      { type: 'quote', text: '阵容的变化是常态，节目能不能留住观众，最终看的还是内容。' },
      { type: 'h2', text: '新赛制值得期待' },
      { type: 'p', text: '据节目组透露，新一季将调整分组机制，增加素人参与的环节。对于长线综艺而言，赛制的迭代往往比阵容的微调更能带来新鲜感。' },
      { type: 'p', text: '节目预计于年内播出，具体档期待官方公布。' },
    ],
  },
];

export const testimonials = [
  {
    name: '熬夜打工人',
    role: '连续围观 180 天',
    text: '以前是东一榔头西一棒子地刷，现在习惯先来这里看时间线，几分钟就能把一件事的来龙去脉捋清楚。',
  },
  {
    name: '理性吃瓜小组',
    role: '内容共建者',
    text: '这里的整理会区分“已确认”和“待核实”，不会把猜测当成事实，这一点在娱乐资讯里挺难得。',
  },
  {
    name: '南方的猫',
    role: '资深围观群众',
    text: '热榜更新很快，配合专题页看很顺畅。手机上刷也不卡，晚上躺在床上刷两屏正好。',
  },
];

export const faqs = [
  {
    q: '爆料吃瓜上的内容来源是什么？',
    a: '站内内容由编辑团队基于公开渠道的信息整理而成，重点在于把分散的消息按时间线梳理清楚，并标注哪些是已确认信息、哪些仍待核实。',
  },
  {
    q: '为什么文章里的人物都使用代称？',
    a: '为避免对具体个人造成不必要的困扰，我们统一使用“某艺人”“百万粉博主”这类代称，并坚持不发布未经核实的指控性内容。',
  },
  {
    q: '我可以投稿自己的线索吗？',
    a: '可以。点击导航栏的“我要爆料”即可进入投稿页面，填写线索概述与联系方式。编辑会先做核实，再决定是否整理成文。',
  },
  {
    q: '内容会持续更新吗？',
    a: '会。对仍在发酵的事件，我们会以“进展时间线”的方式持续补充新的节点，更新时间标注在文章顶部，方便你快速看到变化。',
  },
  {
    q: '站内内容可以直接转载吗？',
    a: '欢迎注明出处后转载。如需进行二次加工或商业用途，请先通过投稿页面的邮箱与我们取得联系。',
  },
];